export enum PartnerType {
  FGTS = "FGTS",
  SALVCAR = "SALVCAR",
  CREFAZ = "CREFAZ",
  CREFISA = "CREFISA",
  CREFISA_INSS = "CREFISA_INSS",
  PAN = "PAN",
  CLT = "CLT",
  C6 = "C6",
  CREFAZ_CLT = "CREFAZ_CLT",
}

export const partnerLabels: Record<PartnerType, string> = {
  [PartnerType.FGTS]: "FGTS",
  [PartnerType.SALVCAR]: "Salvcar",
  [PartnerType.CREFAZ]: "Crefaz",
  [PartnerType.CREFISA]: "Crefisa",
  [PartnerType.CREFISA_INSS]: "Crefisa INSS",
  [PartnerType.PAN]: "PAN CLT",
  [PartnerType.CLT]: "Grandino CLT",
  [PartnerType.C6]: "C6 Bank",
  [PartnerType.CREFAZ_CLT]: "Crefaz CLT",
};

export const getPartnerLabel = (type: PartnerType): string =>
  partnerLabels[type] ?? type;
